import { t } from "@/i18n-js/instance";

export const CORE_COLORS = [
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_1"),
    name: "theme-website-color-1",
    variable: "theme-website-color-1",
  },
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_2"),
    name: "theme-website-color-2",
    variable: "theme-website-color-2",
  },
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_3"),
    name: "theme-website-color-3",
    variable: "theme-website-color-3",
  },
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_4"),
    name: "theme-website-color-4",
    variable: "theme-website-color-4",
  },
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_5"),
    name: "theme-website-color-5",
    variable: "theme-website-color-5",
  },
  {
    title: t("builder_ui.css_variables.colors.core_colors.variables.color_6"),
    name: "theme-website-color-6",
    variable: "theme-website-color-6",
  },
];
